import axios from "axios";
import { toast } from "react-toastify";

// Global axios response interceptor: turn any 401 from the API into a clean
// session-ended flow — clear localStorage, toast the user, and redirect to
// /login. Without this, every action handles 401 ad-hoc (most just show a
// silent error toast and leave the user on a broken page).
//
// The 401 source is usually one of:
//   - Natural JWT expiry (10-hour lifetime).
//   - token_version bump server-side (admin or self changed the password).
//   - User row deleted on the server.
//
// Skip the redirect when we're already on /login — login failures bubble up
// to the page-level error handler instead of bouncing the user to themselves.
let isHandling401 = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const onLoginPage =
      typeof window !== "undefined" &&
      (window.location.pathname === "/" ||
        window.location.pathname.toLowerCase().includes("login"));

    if (status === 401 && !onLoginPage && !isHandling401) {
      isHandling401 = true;
      try {
        // Drop every auth blob this app stores. Keys observed in code:
        //   - "admin"        — main user object incl. access_token
        //   - "user"         — older portal-side blob (defensive)
        //   - "access_token" — bare-token shim (defensive)
        ["admin", "user", "access_token"].forEach((k) => {
          try {
            localStorage.removeItem(k);
          } catch (_) {}
        });
        toast.error("Your session has ended. Please sign in again.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
        // Use replace so the broken page isn't in browser history.
        if (typeof window !== "undefined") {
          window.location.replace("/login");
        }
      } finally {
        // Reset after a beat so a double-401 burst doesn't deadlock the
        // flag if window.location.replace is somehow async-deferred.
        setTimeout(() => {
          isHandling401 = false;
        }, 1500);
      }
    }
    return Promise.reject(error);
  },
);
